// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ztwjt","field":"styles_field__3gk0c","fieldCol":"styles_fieldCol__1xiIE","diffCol":"styles_diffCol__rBLfP","diff":"styles_diff__28v6Q"};